import { Fragment, useState, useEffect } from "react";
import { notification, Button, Modal } from "antd";
import { TitleHeader, Searcher, TableAntd } from "../../components";
import { ReloadOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { Redirect } from "react-router-dom";
import { useAuth } from "../../utils/useAuth";
import { executeQuery, executeUpdate } from "../../api/sistema";
import { createColumns } from "./formatTable";

function Ingresante() {
  const { isAdmin } = useAuth();

  const [filterTable, setFilterTable] = useState(null);
  const [page, setPage] = useState(1);

  const [dataToTable, setDataToTable] = useState([]);
  const [reload, setReload] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const fetchDataToTable = async () => {
    setIsLoading(true);

    executeQuery({
      query: "get_all_ingresantes",
      collection: "ing_ingresante"
    })
      .then((res) => {
        setDataToTable(res.payload);
      })
      .catch((err) => {
        notification.error({
          message: "Problemas con la solicitud",
          description: err.message
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchDataToTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  if (!isAdmin) return <Redirect to="/app" />;

  const onChangeState = (record) => {
    const activateMsg = record.activo ? "desactivar" : "activar";
    const actionMsg = record.activo ? "desactivado" : "activado";

    Modal.confirm({
      title: `¿Estás seguro de ${activateMsg} al postulante '${record.nombre}?'`,
      icon: <ExclamationCircleOutlined />,
      okText: "Sí, " + activateMsg,
      cancelText: "Cancelar",
      onOk() {
        executeUpdate(
          {
            collection: "reg_postulante",
            nombreid: "_id",
            valorid: record._id
          },
          {
            activo: !record.activo
          }
        )
          .then((res) => {
            if (res.success) {
              notification.success({
                message: "Operación exitosa",
                description: `Se ha ${actionMsg} al postulante satistactoriamente.`
              });
              fetchDataToTable();
            }
          })
          .catch(() => {
            notification.error({
              message: "Operación no válida",
              description: `No se pudo actualizar el estado, comuníquese con el administrador.`
            });
          });
      }
    });
  };

  const columnsToTable = createColumns(page, onChangeState);

  const search = (value) => {
    const tempFilterTable = dataToTable.filter((o) =>
      Object.keys(o).some((k) => String(o[k]).toLowerCase().includes(value.toLowerCase()))
    );

    setFilterTable(tempFilterTable);
  };

  return (
    <Fragment>
      <TitleHeader
        title={
          <span className="flex gap-2 items-center">
            <h1 className="font-bold">Ingresantes ({dataToTable.length})</h1>
            <Button
              size="small"
              icon={<ReloadOutlined />}
              onClick={() => setReload(!reload)}
            ></Button>
          </span>
        }
      />

      <Searcher onSearch={search} placeholder="Busca algún postulante" />

      <TableAntd
        columns={columnsToTable}
        dataSource={filterTable == null ? dataToTable : filterTable}
        setPage={setPage}
        isLoading={isLoading}
      />
    </Fragment>
  );
}

export default Ingresante;
